import * as React from "react";
import { HexagonIcon } from "@phosphor-icons/react";
import { cn } from "@/zapi-frontend/shared/lib/utils";

import { Tooltip, TooltipContent, TooltipTrigger } from "@libs/zapi-ui/ds/components/tooltip";

function RqaSimLauncher({ className, ...props }: React.ComponentProps<"button"> & { "aria-label": string }) {
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <button
            type="button"
            data-slot="rqasim-launcher"
            className={cn(
              "flex size-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg outline-none transition-[scale] duration-300 hover:scale-105 focus-visible:ring-3 focus-visible:ring-ring/50 active:scale-95",
              className
            )}
            {...props}
          />
        }
      >
        <HexagonIcon weight="duotone" className="size-6" aria-hidden="true" />
      </TooltipTrigger>
      <TooltipContent side="top">Innovera RQASim</TooltipContent>
    </Tooltip>
  );
}

export { RqaSimLauncher };
